module.exports = __webpack_public_path__ + "img/35.b105c5ac.jpg";